import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Button,
  Box,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu"; // Ensure you have imported MenuIcon
import { Link } from "react-router-dom";
import { StaffuseAuth } from "../../../security/StaffuseAuth";

function Header({ isOpen, toggleDrawer }) {
  const { logout } = StaffuseAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <AppBar
      position="static"
      //  color="primary"
      sx={{
        backgroundColor:
          localStorage.getItem("Username") === "curtis@investin.org" ||
          localStorage.getItem("Username") === "rebeccaseymour@investin.org"
            ? "#4C0099"
            : "primary",
      }}
      elevation={4}
    >
      <Toolbar>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          onClick={toggleDrawer(true)}
          sx={{
            width: "40px",
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.2)",
            },
          }}
        >
          <MenuIcon />
        </IconButton>
        <Box sx={{ flexGrow: 1, display: "flex", justifyContent: "flex-end" }}>
          <Button
            color="inherit"
            component={Link}
            to="/Staff"
            sx={{
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.2)",
              },
            }}
          >
            Home
          </Button>
          <Button
            color="inherit"
            component={Link}
            to="/Staff/about"
            sx={{
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.2)",
              },
            }}
          >
            About
          </Button>
          <Button
            color="inherit"
            component={Link}
            to="/Staff/contact"
            sx={{
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.2)",
              },
            }}
          >
            Contact
          </Button>
          <Button
            color="inherit"
            sx={{
              width: "40px",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.2)",
              },
            }}
            onClick={handleLogout}
          >
            Logout
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
